const firebaseConfig = {
    apiKey: "AIzaSyDd2iFNO_LUCqYhA8blNEeZZKEOiFHU5SM",
    authDomain: "volunteer-network-f60dc.firebaseapp.com",
    databaseURL: "https://volunteer-network-f60dc.firebaseio.com",
    projectId: "volunteer-network-f60dc",
    storageBucket: "volunteer-network-f60dc.appspot.com",
    messagingSenderId: "36397229663",
    appId: "1:36397229663:web:cf7d6404fbf3ec304bddea"
  };
  export default firebaseConfig;